import React from 'react';

/**
 * ConversationSearch — campo de busca controlado.
 *
 * Responsabilidade única: input de busca.
 * A renderização dos resultados é responsabilidade do ConversationList.
 *
 * Props:
 *   searchTerm      string     — valor controlado do input
 *   onSearchChange  fn(term)   — callback ao digitar
 */
const ConversationSearch = ({ searchTerm, onSearchChange }) => {
  return (
    <div style={styles.container}>
      <div style={styles.searchBox}>
        <svg style={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          type="text"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          style={styles.input}
        />
        {searchTerm && (
          <button
            style={styles.clearBtn}
            onClick={() => onSearchChange('')}
            title="Limpar busca"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '8px 12px', borderBottom: '1px solid #e5e7eb' },
  searchBox: {
    display: 'flex', alignItems: 'center',
    backgroundColor: '#f3f4f6', borderRadius: '8px',
    padding: '7px 10px', gap: '8px',
  },
  searchIcon: { color: '#6b7280', flexShrink: 0 },
  input: {
    border: 'none', backgroundColor: 'transparent',
    outline: 'none', fontSize: '14px', width: '100%', color: '#111827',
  },
  clearBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    color: '#9ca3af', fontSize: '12px', padding: '0 2px', flexShrink: 0,
  },
};

export default ConversationSearch;
